(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    // Mobile drawer
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { document.body.classList.add('drawer-open'); });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { document.body.classList.remove('drawer-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.body.classList.remove('drawer-open'); }
    });

    // Product media gallery (images, videos, external videos, 3D models)
    var mediaItems = document.querySelectorAll('[data-media-item]');
    if (mediaItems.length) {
      document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-index');
          mediaItems.forEach(function (m) {
            var active = m.getAttribute('data-index') === idx;
            m.classList.toggle('is-active', active);
            if (!active) {
              m.querySelectorAll('video').forEach(function (v) { v.pause(); });
            }
          });
          document.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    }

    // Variant select: update price + availability
    var variantSelect = document.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        if (!opt) { return; }
        var priceEl = document.querySelector('[data-price-current]');
        var compareEl = document.querySelector('[data-price-compare]');
        var addBtn = document.querySelector('[data-add-to-cart]');
        if (priceEl && opt.getAttribute('data-price')) { priceEl.textContent = opt.getAttribute('data-price'); }
        if (compareEl) {
          var cmp = opt.getAttribute('data-compare');
          if (cmp) { compareEl.textContent = cmp; compareEl.hidden = false; } else { compareEl.hidden = true; }
        }
        if (addBtn) {
          var available = opt.getAttribute('data-available') === 'true';
          addBtn.disabled = !available;
          var label = addBtn.getAttribute(available ? 'data-label-add' : 'data-label-soldout');
          if (label) { addBtn.textContent = label; }
        }
      });
    }

    // Quantity steppers
    document.querySelectorAll('[data-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) { return; }
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var min = parseInt(input.min, 10) || 0;
          var val = parseInt(input.value, 10) || min;
          input.value = Math.max(min, val + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Cart: auto-submit on quantity change
    var cartForm = document.querySelector('[data-cart-form]');
    if (cartForm) {
      cartForm.querySelectorAll('.qty input').forEach(function (input) {
        input.addEventListener('change', function () { cartForm.submit(); });
      });
    }
  });
})();